// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-text {
    font-family: 'garamond';
    font-size: 16px;
    font-weight: 500;
    color: #728bcf;
    font-weight: 600px;
}

.title-padding {
    padding-left: 10px;
    padding-top: 10px;
}

.content-text {
    color: black;
    font-weight: 400px;
}

.section-container {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
    border-radius: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}

:host ::ng-deep .ql-editor {
    min-height: 0px;
    padding: 10px
}
  

.copy_button {
    background: white;
    border-radius: 15px;
    color: grey;
    line-height: 30px;
    padding: 0 10px
}

.copy_button:focus {
    background: #54c74a;
    color: white
}`, "",{"version":3,"sources":["webpack://./src/app/role-detail/role-template-generator/role-template-generator.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,wFAAwF;IACxF,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ","sourcesContent":[".title-text {\n    font-family: 'garamond';\n    font-size: 16px;\n    font-weight: 500;\n    color: #728bcf;\n    font-weight: 600px;\n}\n\n.title-padding {\n    padding-left: 10px;\n    padding-top: 10px;\n}\n\n.content-text {\n    color: black;\n    font-weight: 400px;\n}\n\n.section-container {\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;\n    border-radius: 20px;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n:host ::ng-deep .ql-editor {\n    min-height: 0px;\n    padding: 10px\n}\n  \n\n.copy_button {\n    background: white;\n    border-radius: 15px;\n    color: grey;\n    line-height: 30px;\n    padding: 0 10px\n}\n\n.copy_button:focus {\n    background: #54c74a;\n    color: white\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
